import React, { useContext } from "react";
import pcpLogo from '../../images/pcp-logo-green.png';
import pcLogo from '../../images/pc-logo-green.png';
import { getMediaUrl } from '../../utils/utils';
import { AppContext } from '../../AppContext';
import "./UpgradeBanner.scss";
import BrowserLink from "../BrowserLink";

export function UpgradeBanner({
  access,
  description,
  title
}) {
  const { user } = useContext(AppContext);

  function handleSignInClick(e) {
    window.showPopupLogin();
    e.preventDefault();
  }

  function handleStartClick(e) {
    window.showPopupPlan({
      title: 'Start your PokerCoaching membership today to unlock this class!',
      planSet: access === 'Standard' ? 'standard-premium' : access === 'Premium' ? 'premium' : 'free',
      activePremium: access === 'Standard',
      userAccess: user.type,
    });
    e.preventDefault();
  }

  return (
    <div className="UpgradeBanner">
      {access === 'Premium' ? (
        <img src={getMediaUrl(pcpLogo)} alt="pokercoaching premium" className="UpgradeBanner__logo" />
      ) : (
        <img src={getMediaUrl(pcLogo)} alt="pokercoaching be the shark" className="UpgradeBanner__logo" />
      )}
      <p className="UpgradeBanner__description">{description}</p>
      <p>
        {user.type === 'guest' && (
          <span><BrowserLink href="/" onClick={handleSignInClick}>Sign in</BrowserLink> or </span>
        )}
        <BrowserLink href="/" onClick={handleStartClick}>Start your PokerCoaching membership today</BrowserLink>
      </p>
      <p className="UpgradeBanner__title">{title}</p>
    </div>
  );
}
